const en = {
  modules: [
    {
      template: 'authorModule',
      text: `<p>
                
                Photography and Video by <strong>Erin Brethauer</strong> & <strong>Tim Hussin</strong> Article written by <strong>Rachel Barth</strong> Article edited by <strong>Sean Conroy</strong>
            </p>`
    },
    {
      template: 'leadModule',
      body: `"I came to this country to save my life."`
    },
    {
      template: 'textModule',
      text: `<p>
                High on a hill and up a steep driveway sits a small building overlooking Spring Valley in San Diego County. Through a sliding screen door and into an office, people race by, dodging piles of donated clothing and stacks of folding chairs. This is the headquarters of the Minority Humanitarian Foundation (MHF), a nonprofit organization founded by Mark Lane to provide relief efforts to migrants and asylum seekers at the San Diego border. 
            </p>
            <p>
                Mark and MHF team member Jules Kramer sit in their office, half-hidden under stacks of paperwork (mostly asylum packets) and handmade thank-you cards—mementos of gratitude for the work they do, often without pay or sleep, simply “because we can.” MHF is run by Jules and Mark, with the help of volunteers, and it’s a bootstrapped operation working simply to offer what has been most absent during these immigrants’ long journeys: basic humanity.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery1-1.jpg',
          index: '01',
          alt: 'Jules on a phone call in the Minority Humanitarian Fund office',
          caption: `<p>Jules takes a call from an asylum-seeker who was just released</p>`
        },
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery1-2.jpg',
          index: '02',
          alt: `'Tattoo on Mark's arm reads "Die A Hero"'`,
          caption: `<p>Mark describes his tattoo, “It’s from Batman—‘Die a hero, before you become the villain.’”</p>`
        },
        {
          width: 426,
          height: 314,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery1-3.jpg',
          index: '03',
          alt: `'Mark and his son in the Minority Humanitarian Fund office'`,
          caption: `<p>Mark takes a moment to talk to his son in the MHF office</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'We know we’re only affecting a very, very small percentage of people, but we’re just trying to make the biggest impact we can.',
      cite: 'Jules'
    },
    {
      template: 'textModule',
      text: `<p>
                Every day thousands of asylum-seeking migrants wait in makeshift shelters in Tijuana, holding their places in line for processing at a US detention center. But, each day, only a few dozen are called, a process slowed by never-ending administrative roadblocks. All the while, at seemingly every advance: more waiting. Waiting to arrive, waiting in shelters, waiting in lines, waiting for numbers to be called, waiting for answers.
            </p>
            <p>
                If called for processing, migrants enter a cold, crowded cell for days, weeks, sometimes months, as US officials decide whether they will be tagged with an ankle bracelet and granted temporary entry or deported back to their home countries. If granted parole in the United States, these legal immigrants are typically released along a road in San Diego without any money in hand or the opportunity to make a phone call. Their paperwork is written in English, making it difficult to understand, and they are given no direction as to where to go next.
            </p>
            <p>
                Amidst that uncertainty, Mark and Jules help ground them, providing basics during these vulnerable moments of transition, their very first moments in the United States.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 328,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery2-1.jpg',
          index: '01',
          alt: 'Mark and Jules load their vehicle with supplies for the migrant shelters',
          caption: `<p>Mark and Jules pick-up supplies for a donation run</p>`
        },
        {
          width: 426,
          height: 639,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery2-2.jpg',
          index: '02',
          alt: 'Jules in the storage facility where they keep supplies',
          caption: `<p>Jules loads supplies at the MHF storage facility</p>`
        },
        {
          width: 426,
          height: 315,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery2-3.jpg',
          index: '03',
          alt: 'Jules at the storage facility where they keep supplies',
          caption: `<p>Jules preparing for the next supplies drop-off.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'You walk up to some very scared people. They don’t know what to do. We immediately find out: ‘What do you need right now?’ It’s almost always food and a shower. It’s really simple.',
      cite: 'Mark'
    },
    {
      template: 'textModule',
      text: `<p>
                From minute to minute, Mark and Jules respond to calls from migrants in need; provide food, clothes, and temporary housing; and coordinate transportation. They dispatch Lyft rides to meet those left at the border (Mark himself is a Lyft driver, too) or they themselves will wait roadside for hours when they know a dropoff is likely to happen. They act at a pace akin to emergency medical technicians—only they must be the dispatchers, the medics, the hospitals, and the rehabilitation programming all in one. And their work begins before the migrants even land on US soil.
            </p>`
    },
    {
      template: 'fullImageModule',
      url: 'assets/images/story/story-borderlands/borderlands-full-image1.jpg',
      width: 1240,
      height: 930,
      alt: 'The Mexico side of the border wall'
    },
    {
      template: 'chapterModule',
      title: 'Shelter For Now',
      subtitle: '',
      dateLocation: ''
    },
    {
      template: 'textModule',
      text: `<p>
                Jules, her green hair tied back in a ponytail, watches out the window as the rubbled streets of Tijuana pass by. Beyond the window is Friendship Park, on the vibrant, colorful Mexican side of the border wall. It’s muraled and lined with gardens and orchestral mariachi bands—a stark contrast to the near-sterile San Diego visible through the bars. Back in the car, the seats behind Jules are loaded with diapers, feminine-hygiene products, clothes, toys, and other relief supplies the foundation brings to shelters on a tri-weekly basis.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 328,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery3-1.jpg',
          index: '01',
          alt: 'Tents at one of the migrant shelters',
          caption: `<p>Tents are arranged at the migrant shelter as a makeshift sleeping area.</p>`
        },
        {
          width: 426,
          height: 432,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery3-2.jpg',
          index: '02',
          alt: 'Migrants waiting in line at the shelter kitchen',
          caption: `<p>Migrants wait in line for food from the shelter kitchen.</p>`
        },
        {
          width: 426,
          height: 328,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery3-3.jpg',
          index: '03',
          alt: 'Clothes hanging to dry on laundry lines outside the shelter',
          caption: `<p>Laundry hanging to dry in the afternoon sun outside the shelter.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'They just walked across a continent, they left everything they knew, and now they’re in purgatory just waiting for their number to be called.',
      cite: 'Jules'
    },
    {
      template: 'textModule',
      text: `<p>
                Deeper into Tijuana at the Movimiento Juventud 2000 shelter, some one hundred people crowd into a small aluminum structure. These are asylum seekers, waiting their turn. They fill the space, eating, talking, passing the time. Parents hold their children, wash clothes, cook. Kids play tag. Conditions are dire—people sleep in tents or on stained mattresses, and some individuals are covered with visible rashes and pox—but the energy is a patient one. Many migrants still prefer passing time in these shelters to living with the dangers that came before,and many will wait for months while following the prescribed order of events for seeking asylum in the United States.
            </p>`
    },
    {
      template: 'videoModule',
      index: '01',
      caption: 'Jules visits Tijuana shelters.',
      posterImage: {
        width: 1440,
        height: 810,
        url: 'assets/images/story/story-borderlands/borderlands-video-poster1.jpg'
      },
      videoURL:
      'https://player.vimeo.com/external/345139526.sd.mp4?s=b0a34b3bee9f30ea87aa061ef377a6f4c24e5bc3&profile_id=165'
    },
    {
      template: 'quoteModule',
      quote: 'If they miss their number being called, they have to get a new number. It all starts all over again.',
      cite: 'Jules'
    },
    {
      template: 'textModule',
      text: `<p>
                While in the shelters, they’re waiting for their number in line to be called—a system known among migrants as “the lottery.” It’s a handwritten book kept by Mexican immigration authorities that lists which asylum seekers will be handed over to US Citizenship and Immigration Services for processing each day.
            <p>
                Jules unloads the supplies from her car. She’s all business here: engaging with new and familiar faces, handing out business cards, making eye contact, smiling: basic acts to begin the process of dignifying and humanizing this migrant community. “We give people our business cards who are going to be processing and tell them, ‘Call us when you get released. Call us.’”
            </p>`
    },
    {
      template: 'chapterModule',
      title: 'America In Ankle Bracelets',
      subtitle: '',
      dateLocation: ''
    },
    {
      template: 'textModule',
      text: `<p>
                Oscar, a man in his thirties, squints as he steps into the sunlight outside the fast food chain where he’s spent his first hours in the United States. He was released from a US detention center without assistance or instruction, so he called Mark and Jules.
            </p>
            <p>
                Oscar holds the hand of his six-year-old daughter. Around his ankle is a GPS-monitored electronic bracelet which he must keep charged until his case is decided. Trailing them is his wife, also tagged with an electronic bracelet. In her arms is their six-month-old baby, who scans the new terrain from her mother’s hip.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 320,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery4-1.jpg',
          index: '01',
          alt: 'A mother and child are picked-up by Mark and Jules after leaving the detention center',
          caption: `<p>After leaving the detention center, a family calls Mark and Jules for assistance.</p>`
        },
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery4-2.jpg',
          index: '02',
          alt: 'A close-up on a woman wearing an ankle bracelet',
          caption: `<p>After leaving the detention center, asylum-seekers must wear an ankle bracelet at all times until their court date.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: 'I thank God that we got on this side. Now my daughters will have a future.',
      cite: 'Oscar'
    },
    {
      template: 'videoModule',
      index: '02',
      caption: '<p>Mark and Jules respond to a call that a family was released at the border.</p>',
      posterImage: {
        width: 1440,
        height: 810,
        url: 'assets/images/story/story-borderlands/borderlands-video-poster2.jpg'
      },
      videoURL:
      'https://player.vimeo.com/external/345139573.sd.mp4?s=d8b23c79503770b48a275cf341de73b75f14a734&profile_id=165'
    },
    {
      template: 'textModule',
      text: `<p>
                For the last two days, inside detention, Oscar was separated from his wife and daughters and placed in an all-male holding cell. Occupants dubbed it the “Ice Box” because of its frigid, windowless conditions. 
            </p>
            <p>
                Less than an hour after receiving Oscar’s phone call, Mark and Jules—who met him on a donations run on the other side of the border—are checking him and his family into a nearby motel. Mark explains to Oscar how to use the shower and lights, while Jules works on reuniting them with friends across the US. She gets help from Miles4Migrants, a nonprofit organization that uses donated frequent flyer miles to reunite refugees with families. 
            </p>
            <p>
                Oscar’s six-year-old is excitedly chattering about the pool across the parking lot, and the baby is laughing at whatever babies laugh at. Even now, they feel just a little more human.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 568,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery5-1.jpg',
          index: '01',
          alt: 'A hand on the curtain in a motel room',
          caption: `<p>The family takes a moment to breathe as they settle into their motel room.</p>`
        },
        {
          width: 426,
          height: 577,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery5-2.jpg',
          index: '02',
          alt: 'A young baby looks at the camera',
          caption: `<p>Oscar and his wife are relieved that their children are safe.</p>`
        }
      ]
    },
    {
      template: 'textModule',
      text: `<p>
               He touches his ankle bracelet. “It would seem this is only worn by people that have problems with the law,” he says, “but it’s also proof that I didn’t come violating the laws of this country, that I want to do things right.”
            </p>`
    },
    {
      template: 'videoModule',
      index: '03',
      caption: 'In their hotel room, the family tells us about their experience.',
      posterImage: {
        width: 1440,
        height: 810,
        url: 'assets/images/story/story-borderlands/borderlands-video-poster3.jpg'
      },
      videoURL:
      'https://player.vimeo.com/external/345139684.sd.mp4?s=7e9ae8a8b4f2640b558358723802bb9eb33f4a96&profile_id=165'
    },
    {
      template: 'quoteModule',
      quote: 'They’re going through a process that’s legal. We should treat them like human beings.',
      cite: 'Mark'
    },
    {
      template: 'textModule',
      text: `<p>
                Tomorrow they plan to fly out, and they’ll be one day closer to their first court date, likely to be followed by several more court dates. Eventually, they will learn whether they can stay. <em>Eventually</em>. The process can take up to three years. 
            </p>
            <p>
                Oscar knows they’re lucky to have friends in the United States, lucky to have a place to fly to and wait out the uncertain asylum process. And, for tonight at least, they’re not out on the street. He and his wife sleep close to the outlet to charge their ankle bracelets. But they’re together, and they’re safe.  
            </p>`
    },
    {
      template: 'chapterModule',
      title: 'Idle-lands'
    },
    {
      template: 'textModule',
      text: `<p>
                It’s 2:15 p.m. on a school day, and Honduran asylum seeker Mari waits for her teenage son Javi outside an elementary school in San Diego. After landing with the caravan in Tijuana, they were able to gain parole in the United States. But without anyone to receive them, Mari and Javi, who has Down’s syndrome, have remained in a homestay in San Diego for the last seven months.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 568,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery6-1.jpg',
          index: '01',
          alt: `'Javi holds his mother's hand'`,
          caption: `<p>Mari and Javi's close bond helps them survive the waiting.</p>`
        },
        {
          width: 426,
          height: 428,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery6-2.jpg',
          index: '02',
          alt: 'Mari picks up her son, Javi, from elementary school',
          caption: `<p>Mari picks up her son, Javi, from the elementary school he's been attending since arriving in San Diego.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'I don’t have family here. I don’t have anyone. I felt very good because my son was going to get treated by doctors, but I was afraid because I didn’t have anywhere to go.',
      cite: 'Mari'
    },
    {
      template: 'textModule',
      text: `<p>
                Javi turns the corner and beams upon seeing his mom. He kisses her cheek and proudly sings her the alphabet, while Mari, glowing, sweeps the hair from his eyes. 
            </p>
            <p>
                “In Honduras there’s no school for these children,” she says. “They never accepted my son at school because of the problem that he has, but he wanted to study very much. And that’s why I risked my life to come where I am now.”
            </p>
            <p>
                Mari isn’t exaggerating when she speaks about threats to her life. “I remember helping Mari unpack, and the last thing was this folder,” says Jules. “And it was a folder full of different pictures of her dead relatives in their caskets. Like, this is her whole family and they’re dead and now she’s in this country. She has a son with Down’s syndrome and she’s doing the best she can.”
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 568,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery7-1.jpg',
          index: '01',
          alt: 'Mari sits alone in the bedroom where she is staying with her son',
          caption: `<p>Mari in the bedroom where she is staying with her son, Javi.</p>`
        },
        {
          width: 426,
          height: 577,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery7-2.jpg',
          index: '02',
          alt: 'Javi looks at the camera, pensively',
          caption: `<p>An interminable waiting is part of the experience for asylum-seekers.</p>`
        }
      ]
    },
    {
      template: 'textModule',
      text: `<p>
                To Mari, her best means finding work and securing an apartment for her and Javi. Asylum seekers are eligible for work permits six months from the date they turn in their petition for asylum at their first court date, which sometimes takes months to arraign.
            </p>
            <p>
                And while Mari and Javi enjoy the first months of his education, the future is unresolved. Like the others, they still must wait to see if they will be granted asylum in the United States. If rejected, they’ll be sent back to Honduras, to what’s left of a home.
            </p>`
    },
    {
      template: 'chapterModule',
      title: 'American Dreamer'
    },
    {
      template: 'textModule',
      text: `<p>
                Jose Galvan immigrated with his parents from Mexico twenty-three years ago. He has lived in San Diego since he was two years old; he is a theater director, an artist, a Lyft driver, and a Deferred Action for Childhood Arrival (DACA) recipient. He’s the first in his family to graduate college. And though his DACA status allows him and other so-called “Dreamers” to stay without threat of deportation, recipients must reapply every two years.
            </p>
            <p>
                “It has become a part of my everyday life,” he says. “No new applicants can apply for the program, but anybody under the program is able to still renew. That’s hundreds of thousands of people who still have protection. But that can change any moment.”
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 428,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery8-1.jpg',
          index: '01',
          alt: 'Jose walks through the hills overlooking San Diego',
          caption: `<p>Jose walks through the hills overlooking San Diego.</p>`
        },
        {
          width: 426,
          height: 568,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery8-2.jpg',
          index: '02',
          alt: 'Jose blocks the sun from his face',
          caption: `<p>For DACA recipients like Jose, the future is uncertain.</p>`
        }
      ]
    },
    {
      template: 'textModule',
      text: `<p>
                The fee to reapply for DACA status is $495 each time. And even for Dreamers, there is no path to citizenship, or even legal permanent residence. Before the DACA program began in 2012, there was no way to turn academic success into something more. No social security number meant no driver’s license or any other form of legal identification. No legal identification meant no real employment prospects. These adults who had been brought to the United States as children were forced into a state of impermanence and hiding.
            </p>`
    },
    {
      template: 'videoModule',
      index: '04',
      caption: '<p>Jose shares his perspective as an American and a DACA recipient.</p>',
      posterImage: {
        width: 1440,
        height: 810,
        url: 'assets/images/story/story-borderlands/borderlands-video-poster4.jpg'
      },
      videoURL:
      'https://player.vimeo.com/external/345139712.sd.mp4?s=be5642e41e69b14c3e5315e1931274df446c8211&profile_id=165'
    },
    {
      template: 'quoteModule',
      quote:
        'This country was founded on this idea of the American dream, that anybody can make something better for themselves. But it’s becoming a more narrow scope of, like, ‘Well, who was the American dream actually for?',
      cite: 'Jose'
    },
    {
      template: 'textModule',
      text: `<p>
                Even stuck in the in-between, Jose and his family refuse to stop pushing forward with even a  compromised American dream. “My brother graduated college just a few weeks ago,” he says. “He’s the second in our family to do so. We’re starting a legacy of higher education and so we’re showing that we are capable given the opportunity. Many people are not given that opportunity."
            </p>`
    },
    {
      template: 'chapterModule',
      title: 'Homeward Bound?'
    },
    {
      template: 'textModule',
      text: `<p>
                For many immigrants in America, the opportunity to build a secure home can feel continually just beyond reach, even when following all the right steps.
            </p>
            <p>
                It’s been days now since Oscar and his family first stepped into America. They have been shuffled between motels and host homes after their flight was repeatedly cancelled due to weather. 
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 568,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery9-1.jpg',
          index: '01',
          alt: 'A young girl waves from a window',
          caption: `<p>Jules picks-up the family for their flight.</p>`
        },
        {
          width: 426,
          height: 428,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery9-2.jpg',
          index: '02',
          alt: 'Oscar kneels on a suitcase to zip it closed',
          caption: `<p>Oscar finishes packing before the family heads to the airport.</p>`
        },
        {
          width: 426,
          height: 428,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery9-3.jpg',
          index: '03',
          alt: 'A young girl pulls a suitcase',
          caption: `<p>The family's journey continues.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'In 2018, 65 percent of those seeking asylum in the United States were denied entry, and sent back to the conditions to which they came. The public is still waiting on the numbers for 2019. '
    },
    {
      template: 'textModule',
      text: `<p>
                They’re trying again to fly. Jules rides by their side to the airport; for most who take this trip, it will be their first time on a plane. She helps the family check in and walks them through security and up to the boarding area. Then she says goodbye. 
            </p>
            <p>
                “We don’t know what’s going to happen after this,” says Jules, pausing to reflect. “Mark and I are two people just scrambling like chickens with our heads cut off trying to save the world. We know we’re only affecting a very, very small percentage of people, but we’re just trying to make the biggest impact we can with those people.”
            </p>`
    },
    {
      template: 'fullImageModule',
      url: 'assets/images/story/story-borderlands/borderlands-full-image2.jpg',
      width: 1240,
      height: 930,
      alt: 'Oscar and his family wait at the airport for their flight'
    },
    {
      template: 'textModule',
      text: `<p>
                Then Jules is back on her phone, arranging to meet a young woman who may be dropped off by bus late at night on the side of the road in San Diego. She doesn’t want the woman to have to wait alone. 
            </p>
            <p>
                For Oscar and his family, for Mari and Javi, for Jose, and for thousands of others, the wait to stay continues.
            </p>`
    },
    {
      template: 'donateModule',
      title: 'Make a Donation',
      subtitle: 'And join our efforts',
      body: `<p> 
                Every issue contributing to our current immigration crisis is interconnected. Your stories inspire us to continue to take a stand — when our community of riders and drivers is threatened, we’re encouraged to take action.  
                <br><br>
                To help protect the rights of asylum-seeking refugees in the United States, we are humbled to support the <a href="https://www.minorityhumanitarianfoundation.com/" target="_blank">Minority Humanitarian Foundation</a>, led by Mark and Jules featured in this story. MHF provides a humanitarian response to asylum-seeking refugees through on-the-ground relief efforts and more.
                <br><br>
                Please join us in supporting them.
             </p>`,
      cta: 'Make a donation',
      url: 'https://www.minorityhumanitarianfoundation.com/'
    },
    {
      template: 'nextStoryModule',
      id: 'story-bad-hombre',
      title: 'Bad Hombre',
      alt: 'Punch in his car',
      location: 'Los Angeles, CA',
      description: 'Forever from Los Angeles',
      imageSize1URL: 'assets/images/carousel/carousel-image-badhombre-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-badhombre-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/345169298.sd.mp4?s=399e27884c2795481aecc79d78ec3bf1225025c2&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/345162331.sd.mp4?s=d0f7d3364ea3cb7763616517ad116fc7131882f5&profile_id=165'
    }
  ]
};

const es = {
  modules: [
    {
      template: 'authorModule',
      text: `<p>
                
                Fotografía y video de <strong>Erin Brethauer</strong> y <strong>Tim Hussin</strong> Artículo escrito por <strong>Rachel Barth</strong> Artículo editado por <strong>Sean Conroy</strong>
            </p>`
    },
    {
      template: 'leadModule',
      body: `"Vine a este país para salvar mi vida".`
    },
    {
      template: 'textModule',
      text: `<p>
                En lo alto de una colina y en un camino empinado se encuentra un pequeño edificio con vista a Spring Valley, en el condado de San Diego. A través de una puerta de malla corrediza para entrar a una oficina, la gente corre, esquivando montones de ropa donada y pilas de sillas plegables. Esta es la sede de la Minority Humanitarian Foundation (MHF), una organización no lucrativa fundada por Mark Lane para brindar ayuda humanitaria a los inmigrantes y solicitantes de asilo en la frontera de San Diego. 
            </p>
            <p>
                Mark y Jules Kramer, miembro del equipo de MHF, se sientan en su oficina, casi sepultados por pilas de papeles (en su mayoría paquetes de asilo) y tarjetas de agradecimiento hechas a mano: recuerdos de gratitud por el trabajo que realizan, a menudo sin paga ni sueño, y que lo hacen simplemente "porque pueden". MHF está dirigida por Jules y Mark, cuentan con la ayuda de voluntarios, y es una operación autofinanciada que ofrece eso que ha hecho más falta durante los largos viajes de estos inmigrantes: la humanidad elemental".
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery1-1.jpg',
          index: '01',
          alt: 'Jules en una llamada telefónica en la oficina de MHF',
          caption: `<p>Jules recibe una llamada de un solicitante de asilo que acaba de ser liberado</p>`
        },
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery1-2.jpg',
          index: '02',
          alt: `'El tatuaje en el brazo de Mark dice "Muere como héroe"'`,
          caption: `<p>Mark describe su tatuaje: "Es de Batman: 'Muere como héroe, antes de que te conviertas en el villano'".</p>`
        },
        {
          width: 426,
          height: 314,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery1-3.jpg',
          index: '03',
          alt: `'Mark y su hijo en la oficina de MHF'`,
          caption: `<p>Mark se toma un momento para hablar con su hijo en la oficina de MHF</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'Sabemos que solo estamos afectando a un porcentaje muy, muy pequeño de personas, pero estamos tratando de lograr el mayor impacto posible.',
      cite: 'Jules'
    },
    {
      template: 'textModule',
      text: `<p>
                Todos los días miles de inmigrantes que buscan asilo esperan en refugios improvisados en Tijuana, haciendo fila en sus lugares para ser procesados en un centro de detención de los Estados Unidos. Pero diariamente solo se les llama a unas cuantas docenas, un proceso que se alenta por interminables obstáculos administrativos. Y cuando, aparentemente, se logra avanzar un poco: hay más espera. Esperando para llegar, esperando en refugios, esperando en filas, esperando que llamen tu número, esperando respuestas.
            </p>
            <p>
                Si se solicita el procesamiento, los inmigrantes ingresan a una celda fría y aglomerada durante días, semanas, a veces meses, mientras los funcionarios de EE. UU. deciden si se les marcará con un brazalete de tobillo y se les otorgará la entrada temporal o serán deportados a sus países de origen. Si se les otorga la libertad condicional en los Estados Unidos, los inmigrantes legales generalmente son liberados a lo largo de una carretera en San Diego sin dinero o la oportunidad de hacer una llamada telefónica. Sus documentos están escritos en inglés, lo que dificulta su comprensión, y no se les da ninguna indicación de lo que deben hacer después.
            </p>
            <p>
                En medio de toda esa incertidumbre, Mark y Jules ayudan a orientarlos, brindándoles información básica durante esos momentos vulnerables de transición, sus primeros momentos en los Estados Unidos.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 328,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery2-1.jpg',
          index: '01',
          alt: 'Mark y Jules cargan provisiones para los refugios para inmigrantes en su vehículo',
          caption: `<p>Mark y Jules pasan por provisiones para una recaudación de donativos</p>`
        },
        {
          width: 426,
          height: 639,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery2-2.jpg',
          index: '02',
          alt: 'Jules en el almacén donde guardan las provisiones',
          caption: `<p>Jules carga provisiones en las instalaciones de almacenamiento de MHF</p>`
        },
        {
          width: 426,
          height: 315,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery2-3.jpg',
          index: '03',
          alt: 'Jules en el almacén donde guardan las provisiones',
          caption: `<p>Jules se prepara para la próxima entrega de provisiones.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'Te acercas a personas muy asustadas. No saben qué hacer. Lo averiguamos de inmediato: "¿Qué necesitas ahora?" Casi siempre es comida y un baño. Es muy simple.',
      cite: 'Mark'
    },
    {
      template: 'textModule',
      text: `<p>
                De un minuto a otro, Mark y Jules responden a las llamadas de los inmigrantes necesitados; proveen comida, ropa y alojamiento temporal; y coordinan su transportación. Envían viajes de Lyft para encontrarse con los que quedan en la frontera (además, Mark es conductor de Lyft) o ellos mismos esperan en la carretera durante horas cuando saben que puede llegar un nuevo convoy. Operan a un ritmo similar del de los técnicos durante emergencias, solo que ellos juegan todos los papeles a la vez: despachadores, médicos, hospitales y los programadores de rehabilitación. Su trabajo empieza incluso antes de que los migrantes lleguen a tierra estadounidense.
            </p>`
    },
    {
      template: 'fullImageModule',
      url: 'assets/images/story/story-borderlands/borderlands-full-image1.jpg',
      width: 1240,
      height: 930,
      alt: 'El lado mexicano de la frontera'
    },
    {
      template: 'chapterModule',
      title: 'Un refugio, por ahora',
      subtitle: '',
      dateLocation: ''
    },
    {
      template: 'textModule',
      text: `<p>
                Jules, con su pelo teñido de verde recogido en una coleta, mira las calles de Tijuana pasar por la ventana. Del otro lado está el Parque de la Amistad, en el vibrante y colorido lado mexicano del muro fronterizo. Está decorado con murales y delineado por jardines en los que tocan bandas de mariachi. Es un marcado contraste con el estoicismo de San Diego, que se puede ver a través de los barrotes. De vuelta en el auto, los asientos detrás de Jules están llenos de pañales, productos de higiene femenina, ropa, juguetes y otras provisiones de auxilio que la fundación trae a los refugios cada tres semanas.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 328,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery3-1.jpg',
          index: '01',
          alt: 'Las tiendas en uno de los refugios para inmigrantes',
          caption: `<p>Las tiendas se usan como un área de descanso improvisada en el refugio para inmigrantes.</p>`
        },
        {
          width: 426,
          height: 432,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery3-2.jpg',
          index: '02',
          alt: 'Inmigrantes hacen fila en la cocina del refugio',
          caption: `<p>Ropa colgada secándose al sol una tarde afuera del refugio.</p>`
        },
        {
          width: 426,
          height: 328,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery3-3.jpg',
          index: '03',
          alt: 'Ropa colgada secándose al sol afuera del refugio',
          caption: `<p>Ropa colgada secándose al sol una tarde afuera del refugio.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'Acaban de cruzar un continente, dejaron todo lo que conocían y ahora están en el purgatorio esperando que les llamen.',
      cite: 'Jules'
    },
    {
      template: 'textModule',
      text: `<p>
                Dentro de Tijuana, en el refugio Movimiento Juventud 2000, unas cien personas se aglomeran en una pequeña estructura de aluminio. Son solicitantes de asilo, esperando su turno. Llenan el ambiente, comen, hablan, pasan el tiempo. Los padres sostienen a sus hijos, lavan la ropa, cocinan. Los niños juegan y se corretean. Las condiciones son extremas: las personas duermen en tiendas de campaña o en colchones manchados, y algunas personas están cubiertas con erupciones y viruela visibles, pero se vive paciencia en el ambiente. Muchos inmigrantes prefieren estar en estos refugios a vivir bajo las amenazas que sufrían antes. Muchos esperarán durante meses y seguirán el protocolo establecido para buscar asilo en los Estados Unidos.
            </p>`
    },
    {
      template: 'videoModule',
      index: '01',
      caption: 'Jules visita un refugio en Tijuana.',
      posterImage: {
        width: 1440,
        height: 810,
        url: 'assets/images/story/story-borderlands/borderlands-video-poster1.jpg'
      },
      videoURL: 'https://player.vimeo.com/external/350389719.sd.mp4?s=0357aa09397c960eb48a167e9bb1f6c1f5bb56e9&profile_id=165',
      videoSubtitles: [
        {label: 'Spanish subtitles', lang: 'es', src: 'assets/subtitles/borderlands_1.vtt'}
      ]
    },
    {
      template: 'quoteModule',
      quote: 'Si no escuchan cuando llaman su número, tienen que obtener uno nuevo. Todo el proceso vuelve a empezar.',
      cite: 'Jules'
    },
    {
      template: 'textModule',
      text: `<p>
                Mientras se encuentran en los refugios, esperan a que llamen su número en la fila, un sistema conocido entre los inmigrantes como "la lotería". Es un libro escrito a mano por las autoridades de inmigración mexicanas que enumera qué solicitantes del refugio serán entregados cada día a los Servicios de ciudadanía e inmigración de los Estados Unidos para que se procesen.
            <p>
                Jules baja las provisiones de su auto. Cuando viene, está totalmente concentrada: convive con caras nuevas y familiares, reparte tarjetas de presentación, hace contacto visual, sonríe; acciones básicas para empezar el proceso de dignificación y humanización de esta comunidad inmigrante. "Le damos a las personas que van a ser procesadas nuestras tarjetas de presentación y les decimos: 'Llámanos cuando te liberen. Llámanos'".
            </p>`
    },
    {
      template: 'chapterModule',
      title: 'Estados Unidos con brazaletes en los tobillos',
      subtitle: '',
      dateLocation: ''
    },
    {
      template: 'textModule',
      text: `<p>
                Óscar, un hombre de unos treinta años, entrecierra los ojos mientras camina hacia la luz del sol afuera del restaurante de comida rápida donde pasó sus primeras horas en los Estados Unidos. Fue liberado de un centro de detención de los EE. UU., sin ayuda ni instrucciones, por lo que llamó a Mark y a Jules.
            </p>
            <p>
                Óscar toma la mano de su hija de seis años. Alrededor de su tobillo tiene sujeto un brazalete electrónico monitoreado por GPS que debe mantener cargado hasta que se resuelva su caso. Detrás de ellos viene su esposa, también con un brazalete electrónico marcando su pierna. En sus brazos carga a su bebé de seis meses, que explora el nuevo paisaje desde los brazos de su madre".
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 320,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery4-1.jpg',
          index: '01',
          alt: 'Mark y Jules recogen a una madre y su hijo después de salir del centro de detención',
          caption: `<p>Después de salir del centro de detención, una familia llama a Mark y Jules para pedir ayuda.</p>`
        },
        {
          width: 426,
          height: 640,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery4-2.jpg',
          index: '02',
          alt: 'Primer plano de una mujer que lleva un brazalete de tobillo',
          caption: `<p>Después de salir del centro de detención, los solicitantes de asilo deben usar un brazalete de tobillo en todo momento hasta la fecha de su audiencia en la corte.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: 'Agradezco a Dios que hayamos cruzado a este lado. Ahora mis hijas tendrán un futuro.',
      cite: 'Oscar'
    },
    {
      template: 'videoModule',
      index: '02',
      caption:
        '<p>Mark y Jules responden a la llamada donde se les informa que una familia fue liberada en la frontera.</p>',
      posterImage: {
        width: 1440,
        height: 810,
        url: 'assets/images/story/story-borderlands/borderlands-video-poster2.jpg'
      },
      videoURL:
      'https://player.vimeo.com/external/350389528.sd.mp4?s=53558fe3d1e136006c09bab61c41a41c52cc2518&profile_id=165',
      videoSubtitles: [
        {label: 'Spanish subtitles', lang: 'es', src: 'assets/subtitles/borderlands_2.vtt'}
      ]
    },
    {
      template: 'textModule',
      text: `<p>
                Durante los últimos dos días, dentro de la detención, Óscar fue separado de su esposa e hijas y lo metieron dentro de una celda para hombres. Los ocupantes la llamaron "la congeladora" por sus bajas temperaturas y el hecho de que no tenía ventanas. 
            </p>
            <p>
                Menos de una hora después de recibir la llamada telefónica de Óscar, Mark y Jules, quienes se reunieron con él durante una recaudación de donativos del otro lado de la frontera, lo llevan con su familia a un motel cercano. Mark le explica cómo usar la regadera y las luces, mientras que Jules trabaja para que se rencuentren con los amigos que tienen en todo Estados Unidos. Ella recibe ayuda de Miles4Migrants, una organización sin fines de lucro que utiliza millas de viajero frecuente donadas para reunir a los refugiados con sus familias. 
            </p>
            <p>
                El niño de seis años de Óscar habla emocionado de la piscina en el estacionamiento, mientras el bebé se ríe de lo que sea que los bebés se ríen. Incluso ahora, se sienten un poco más humanos".
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 568,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery5-1.jpg',
          index: '01',
          alt: 'Una mano en la cortina de una habitación de motel.',
          caption: `<p>La familia se toma un momento para respirar mientras se instalan en la habitación de su motel.</p>`
        },
        {
          width: 426,
          height: 577,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery5-2.jpg',
          index: '02',
          alt: 'Un bebé mira a la cámara.',
          caption: `<p>Oscar y su esposa se sienten aliviados de que sus hijos estén a salvo.</p>`
        }
      ]
    },
    {
      template: 'textModule',
      text: `<p>
               Se toca el brazalete del tobillo. "Parecería que esto solo lo usan las personas que tienen problemas con la ley", dice, "pero también es una prueba de que no llegué violando las leyes de este país, que quiero hacer las cosas bien".
            </p>`
    },
    {
      template: 'videoModule',
      index: '03',
      caption: 'En su cuarto de hotel, la familia nos cuenta su experiencia.',
      posterImage: {
        width: 1440,
        height: 810,
        url: 'assets/images/story/story-borderlands/borderlands-video-poster3.jpg'
      },
      videoURL:
        'https://player.vimeo.com/external/350389455.sd.mp4?s=5eb9f52adf2c07fc6bd7471c2695a9feccea96eb&profile_id=165'
    },
    {
      template: 'quoteModule',
      quote: 'Están atravesando por un proceso legal. Deberíamos tratarlos como seres humanos.',
      cite: 'Mark'
    },
    {
      template: 'textModule',
      text: `<p>
                Mañana planean volar, y estarán cada vez más cerca de su primera cita en la corte, a lo que probablemente le seguirán muchas más citas en la corte. Eventualmente, sabrán si pueden quedarse. Eventualmente. El proceso puede llevar hasta tres años. 
            </p>
            <p>
                Óscar sabe que tiene la suerte de contar con amigos en los Estados Unidos, la suerte de tener un lugar a dónde volar y esperar el incierto proceso de asilo. Y, por lo menos, esta noche, no estarán en la calle. Él y su esposa duermen cerca del enchufe para cargar sus brazaletes de tobillo. Pero están juntos, y están a salvo.  
            </p>`
    },
    {
      template: 'chapterModule',
      title: 'Tierras desiertas'
    },
    {
      template: 'textModule',
      text: `<p>
                Son las 2:15 p. m. de un día de escuela, y la solicitante de asilo hondureña, Mari, espera a su hijo adolescente, Javi, en una escuela primaria de San Diego. Después de llegar con la caravana en Tijuana, logró obtener la libertad condicional en los Estados Unidos. Sin embargo, no tenían a nadie quien los recibiera. Mari y Javi, quien tiene síndrome de Down, se han quedado en casa de una familia en San Diego durante los últimos siete meses.
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 568,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery6-1.jpg',
          index: '01',
          alt: `'Javi toma la mano de su madre'`,
          caption: `<p>El estrecho vínculo entre Mari y Javi les ayuda a sobrevivir a la espera.</p>`
        },
        {
          width: 426,
          height: 428,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery6-2.jpg',
          index: '02',
          alt: 'Mari recoge a su hijo, Javi, de la escuela primaria',
          caption: `<p>Mari recoge a su hijo, Javi, de la escuela primaria a la que asiste desde que llegó a San Diego.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'No tengo familia aquí. No tengo a nadie. Me sentí muy bien porque mi hijo sería atendido por médicos, pero tenía miedo porque no tenía a dónde ir',
      cite: 'Mari'
    },
    {
      template: 'textModule',
      text: `<p>
                Javi da vuelta en la esquina y sonríe al ver a su madre. Le da un beso en la mejilla y con orgullo le canta el alfabeto, mientras que Mari, resplandeciente, le quita el pelo que le cubre los ojos. 
            </p>
            <p>
                "En Honduras no hay escuelas para estos niños", dice. “Nunca aceptaron a mi hijo en la escuela debido al problema que tiene, pero él anhelaba mucho estudiar. Y es por eso por lo que arriesgué mi vida para venir a donde estoy ahora".
            </p>
            <p>
                Al hablar sobre las amenazas en su vida, Mari no exagera. "Recuerdo que ayudé a Mari a desempacar y lo último fue esta carpeta", dice Jules. “Y era una carpeta llena de diferentes imágenes de sus parientes muertos en ataúdes. O sea, esta es toda su familia y están muertos y ahora ella está en este país. Ella tiene un hijo con síndrome de Down y está haciendo lo mejor que puede".
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 568,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery7-1.jpg',
          index: '01',
          alt: 'Mari se sienta sola en la habitación donde se hospeda con su hijo',
          caption: `<p>Mari en la habitación donde se hospeda con su hijo Javi.</p>`
        },
        {
          width: 426,
          height: 577,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery7-2.jpg',
          index: '02',
          alt: 'Javi mira pensativo a la cámara',
          caption: `<p>Una espera interminable es parte de la experiencia de los solicitantes de asilo.</p>`
        }
      ]
    },
    {
      template: 'textModule',
      text: `<p>
                Para Mari, lo mejor es encontrar trabajo y asegurar un departamento para ella y Javi. Los solicitantes de asilo son elegibles para permisos de trabajo seis meses después de la fecha en la que entregan su solicitud de asilo en su primera cita en la corte, lo que a veces toma meses en procesarse.
            </p>
            <p>
                Y mientras Mari y Javi disfrutan de los primeros meses de su educación, su futuro aún se resuelve. Al igual que los demás, todavía deben esperar a ver si se les otorgará asilo en los Estados Unidos. Si son rechazados, serán enviados de regreso a Honduras, a lo que quede del lugar al que llamaron hogar".
            </p>`
    },
    {
      template: 'chapterModule',
      title: 'Sueños en los Estados Unidos'
    },
    {
      template: 'textModule',
      text: `<p>
                José Galván emigró con sus padres de México hace veintitrés años. Ha vivido en San Diego desde que tenía dos años; es director de teatro, artista, conductor de Lyft y beneficiario de DACA (Acción Diferida para los Llegados de la Infancia, por sus siglas en inglés). Es el primero en su familia en graduarse de la universidad. Y aunque su estatus de DACA le permite a él y a los otros "Soñadores" permanecer en el país sin amenazas de deportación, los beneficiarios deben volver a presentar la solicitud cada dos años.
            </p>
            <p>
                "Se ha convertido en una parte de mi vida cotidiana", dice. “No se permiten nuevas solicitudes para el programa, pero cualquier persona en el programa puede seguir renovando. Son cientos de miles de personas que todavía tienen protección. Pero esto puede cambiar en cualquier momento".
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 428,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery8-1.jpg',
          index: '01',
          alt: 'José camina por las colinas que ven hacia San Diego',
          caption: `<p>José camina por las colinas que ven hacia San Diego.</p>`
        },
        {
          width: 426,
          height: 568,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery8-2.jpg',
          index: '02',
          alt: 'José tapa el sol de su cara',
          caption: `<p>Para los beneficiarios de DACA, como José, el futuro es incierto.</p>`
        }
      ]
    },
    {
      template: 'textModule',
      text: `<p>
                La tarifa para volver a solicitar el estatus de DACA es de $495 cada vez, e incluso para los Soñadores, no existe un camino hacia la ciudadanía, ni siquiera para solicitar la residencia permanente. Antes de que iniciara el programa de DACA en 2012, no existía ninguna alternativa para transformar el éxito académico en algo más. El no tener un número de seguro social implicaba no tener licencia de conducir ni ninguna otra forma legal de identificación. No tener una identificación legal significaba que no existirían posibilidades de empleo verdadero. Estos adultos que habían sido criados en los Estados Unidos desde niños se veían forzados a vivir en un estado de transitoriedad y ocultamiento.
            </p>`
    },
    {
      template: 'videoModule',
      index: '04',
      caption: '<p>José comparte su punto de vista como estadounidense y beneficiario de DACA.</p>',
      posterImage: {
        width: 1440,
        height: 810,
        url: 'assets/images/story/story-borderlands/borderlands-video-poster4.jpg'
      },
      videoURL:
      'https://player.vimeo.com/external/345139712.sd.mp4?s=be5642e41e69b14c3e5315e1931274df446c8211&profile_id=165',
      videoSubtitles: [
        {label: 'Spanish subtitles', lang: 'es', src: 'assets/subtitles/borderlands_3.vtt'}
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'Este país se fundó con la idea del sueño americano, de que cualquiera puede lograr algo mejor para sí mismo. Pero se está cerrando esa perspectiva, como, "¿Para quién realmente es el sueño americano?"',
      cite: 'Jose'
    },
    {
      template: 'textModule',
      text: `<p>
                Incluso atrapados en medio, José y su familia se niegan a rendirse, incluso con un sueño americano comprometido. "Mi hermano se graduó de la universidad hace unas pocas semanas", dice. "Es el segundo de nuestra familia en hacerlo. Estamos empezando un legado de educación superior y, por lo tanto, estamos demostrando que somos capaces, si nos dan la oportunidad. Mucha gente no tiene esa oportunidad".
            </p>`
    },
    {
      template: 'chapterModule',
      title: '¿Destino a casa?'
    },
    {
      template: 'textModule',
      text: `<p>
                Para muchos inmigrantes en Estados Unidos, la oportunidad de formar un hogar seguro puede sentirse como algo fuera de su alcance, incluso cuando se siguen los pasos que se deben de seguir.
            </p>
            <p>
                Han pasado varios días desde que Óscar y su familia llegaron a Estados Unidos por primera vez. Han estado yendo y viniendo, de moteles a casas de huéspedes luego de que su vuelo fuera cancelado repetidamente por causa del clima".
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 426,
          height: 568,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery9-1.jpg',
          index: '01',
          alt: 'Una niña saluda desde una ventana',
          caption: `<p>Jules recoge a la familia para su vuelo.</p>`
        },
        {
          width: 426,
          height: 428,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery9-2.jpg',
          index: '02',
          alt: 'Óscar se arrodilla junto a una maleta para cerrarla',
          caption: `<p>Óscar termina de empacar antes de que la familia se dirija al aeropuerto.</p>`
        },
        {
          width: 426,
          height: 428,
          url: 'assets/images/story/story-borderlands/borderlands-image-gallery9-3.jpg',
          index: '03',
          alt: 'Una joven tira una maleta',
          caption: `<p>El viaje de la familia continúa.</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'En 2018, se negó el ingreso al 65 por ciento de aquellos que buscaban asilo en los Estados Unidos, y los enviaron de vuelta a las condiciones de las cuales vinieron. La ciudadanía continúa a la espera de las cifras de 2019. '
    },
    {
      template: 'textModule',
      text: `<p>
                Están intentando volar de nuevo. Jules viaja a su lado hasta el aeropuerto. Será su primera vez en un avión para la mayoría de los que hacen este viaje. Ella ayuda a la familia a hacer el "check in" y los guía para pasar por seguridad y los acompaña hasta la zona de embarque. Luego se despide. 
            </p>
            <p>
                "No sabemos lo que ocurrirá después de esto", afirma Jules, que se detiene a reflexionar. "Mark y yo somos dos personas revoloteando como gallinas con nuestras cabezas cortadas tratando de salvar al mundo. Sabemos que solo afectamos a un porcentaje muy ínfimo de personas, pero estamos simplemente tratando de ejercer el mayor impacto que podamos en esas personas".
            </p>`
    },
    {
      template: 'fullImageModule',
      url: 'assets/images/story/story-borderlands/borderlands-full-image2.jpg',
      width: 1240,
      height: 930,
      alt: 'Oscar y su familia esperan en el aeropuerto para su vuelo'
    },
    {
      template: 'textModule',
      text: `<p>
                Más tarde, Jules vuelve a usar su teléfono para quedar con una joven que puede llegar en un autobús a San Diego a altas horas de la noche. No quiere que la mujer espere sola. 
            </p>
            <p>
                Más tarde, Jules vuelve a usar su teléfono para quedar con una joven que puede llegar en un autobús a San Diego a altas horas de la noche. No quiere que la mujer espere sola.
            </p>`
    },
    {
      template: 'donateModule',
      title: 'Haz una donación',
      subtitle: 'Unete a nuestra causa',
      body: `<p> 
                Todos los problemas que contribuyen a nuestra actual crisis de inmigración están interconectados. Tus historias nos inspiran a seguir tomando una postura: cuando nuestra comunidad de viajeros y conductores sea amenazada, nosotros tomaremos las medidas pertinentes. 
                <br><br>
                Para ayudar a proteger los derechos de los refugiados que buscan asilo en los Estados Unidos, nos sentimos honrados en apoyar a la <a href="https://www.minorityhumanitarianfoundation.com/" target="_blank">MHF</a>, dirigida por Mark y Jules que protagoniza esta historia. MHF brinda una respuesta humanitaria a los refugiados que buscan asilo a través de esfuerzos de ayuda en el campo, entre otros.
                <br><br>
                Por favor, únete a nosotros para apoyarlos.
             </p>`,
      cta: 'Haz una donación',
      url: 'https://www.minorityhumanitarianfoundation.com/'
    },
    {
      template: 'nextStoryModule',
      id: 'story-bad-hombre',
      title: 'Bad Hombre',
      alt: 'Ponche en su carro',
      location: 'Los Ángeles, CA',
      description: 'Eternamente desde Los Ángeles',
      imageSize1URL: 'assets/images/carousel/carousel-image-badhombre-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-badhombre-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/345169298.sd.mp4?s=399e27884c2795481aecc79d78ec3bf1225025c2&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/345162331.sd.mp4?s=d0f7d3364ea3cb7763616517ad116fc7131882f5&profile_id=165'
    }
  ]
};

export default {en, es};

